<template>
  <Teleport to="body">
    <div
      v-if="visible"
      ref="menu"
      class="editor-context-menu"
      :class="`editor-context-menu--${theme}`"
      :style="{ left: `${position.x}px`, top: `${position.y}px` }"
      @contextmenu.prevent
    >
      <button type="button" :disabled="!canCutOrCopy" @mousedown.prevent @click="selectAction('cut')">切り取り</button>
      <button type="button" :disabled="!canCutOrCopy" @mousedown.prevent @click="selectAction('copy')">コピー</button>
      <button type="button" @mousedown.prevent @click="selectAction('paste')">貼り付け</button>
    </div>
  </Teleport>
</template>

<script>
export default {
  emits: ['select', 'close'],
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    position: {
      type: Object,
      required: true,
    },
    theme: {
      type: String,
      default: 'light',
      validator: (value) => ['light', 'dark'].includes(value),
    },
    canCutOrCopy: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    visible(isVisible) {
      if (isVisible) {
        document.addEventListener('mousedown', this.closeWhenClickOutside);
        document.addEventListener('keydown', this.closeOnEscape);
      } else {
        document.removeEventListener('mousedown', this.closeWhenClickOutside);
        document.removeEventListener('keydown', this.closeOnEscape);
      }
    },
  },
  mounted() {
    if (this.visible) {
      document.addEventListener('mousedown', this.closeWhenClickOutside);
      document.addEventListener('keydown', this.closeOnEscape);
    }
  },
  beforeUnmount() {
    document.removeEventListener('mousedown', this.closeWhenClickOutside);
    document.removeEventListener('keydown', this.closeOnEscape);
  },
  methods: {
    selectAction(action) {
      this.$emit('select', action);
    },
    closeWhenClickOutside(event) {
      if (this.visible && !this.$refs.menu?.contains(event.target)) this.$emit('close');
    },
    closeOnEscape(event) {
      if (this.visible && event.key === 'Escape') this.$emit('close');
    },
  },
};
</script>

<style scoped>
.editor-context-menu {
  --menu-background: #ffffff;
  --menu-border: #d8dee5;
  --menu-text: #2d3748;
  --menu-hover-background: #edf4f2;
  --menu-disabled-text: #a0aec0;
  position: fixed;
  z-index: 3000;
  min-width: 144px;
  padding: 4px;
  background: var(--menu-background);
  border: 1px solid var(--menu-border);
  border-radius: 6px;
  box-shadow: 0 8px 20px rgb(31 41 55 / 16%);
}

.editor-context-menu--dark {
  --menu-background: #2b3440;
  --menu-border: #4b5563;
  --menu-text: #f7fafc;
  --menu-hover-background: #445263;
  --menu-disabled-text: #8b96a5;
}

.editor-context-menu button {
  display: block;
  width: 100%;
  padding: 7px 10px;
  color: var(--menu-text);
  font: inherit;
  text-align: left;
  background: transparent;
  border: 0;
  border-radius: 4px;
  cursor: pointer;
}

.editor-context-menu button:not(:disabled):hover,
.editor-context-menu button:not(:disabled):focus-visible {
  background: var(--menu-hover-background);
  outline: none;
}

.editor-context-menu button:disabled {
  color: var(--menu-disabled-text);
  cursor: default;
}
</style>
